<mat-card class="question-card center">
  <mat-card-content>
    <mat-label class="mat-title question-text">{{title}}</mat-label>
    <div *ngIf="text">
      <mat-expansion-panel>
        <mat-expansion-panel-header class="right-aligned-header">
          <mat-panel-title></mat-panel-title>
          <mat-panel-description>
            {{toggleText}}
          </mat-panel-description>         
        </mat-expansion-panel-header>       
        <p>{{text}}</p>       
      </mat-expansion-panel>
    </div>
    <div class="clearfix"></div>
    <div *ngIf="ctrl">
      <mat-error *ngIf="invalid">
        <div *ngIf="ctrl.errors.required" [innerHTML]="requiredErrorMessage"></div>
      </mat-error>
    </div>
    <div [formGroup]="form">
      <mat-checkbox color="primary" style="display: none;" [formControl]="getFormControlName" value="1">
      </mat-checkbox>
      <div class="docs-component-category-list">
        <mat-radio-group formControlName="{{question.name}}" class="singleImage">
          <a *ngFor="let category of inputData; let i = index" class="docs-component-category-list-item">
            <mat-radio-button (click)="fixImageSelectedId(category)" disableRipple="true" #radio color="primary"
              [value]="category.code">
              <mat-card class="docs-component-category-list-card" style="    height: 296px !important;
              width: 320px !important;" [style.background-color]="category.imageSelected ? '#00897b' : 'white'">
                <mat-card-content class="docs-component-category-list-card-summary">
                  <img mat-card-image [src]="category.imagePath" class="imagerounded" alt="" />
                  <div style="background-color: #00897b;color: white;padding-left: 10px;padding-right: 10px;  text-overflow: ellipsis;overflow: hidden;
                    text-align: center;" matTooltip="{{category.imageName}}">
                    <span>
                      {{category.imageName}}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </mat-radio-button>
          </a>
        </mat-radio-group>
      </div>
    </div>
  </mat-card-content>
</mat-card>